// extracted by mini-css-extract-plugin
export default {"columnHeader":"columnHeaderDvwzt","link":"linknn7Vr"};